import { render } from "./DownloadModal.vue?vue&type=template&id=3c5d4f78"
import script from "./DownloadModal.vue?vue&type=script&lang=js"
export * from "./DownloadModal.vue?vue&type=script&lang=js"

import "./DownloadModal.vue?vue&type=style&index=0&id=3c5d4f78&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__